import React, { useState, useContext } from 'react'
import { StoresContext } from './Context/Stores'
import StoreForm from './StoreForm'
import Store from './Store'
import Modal from './Modal'
import SVG from './SVG'

const Stores = () => {
  const [showSelector, setShowSelector] = useState(false)

  const storesCtx = useContext(StoresContext)

  const { store, stores } = storesCtx

  // Ensure selected store at top.
  const sortedStores = [
    stores.find((s) => s.bc_hash === store.bc_hash),
    ...stores.filter((s) => s.bc_hash !== store.bc_hash),
  ].filter((s) => s)

  return (
    <main className="bg-gray-100 flex-1">
      <div className="bg-indigo-600">
        <div className="max-w-7xl mx-auto h-40 px-4 sm:px-6 lg:px-8 text-indigo-300 text-5xl font-semibold border-t border-indigo-500"></div>
      </div>
      <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 md:px-8 -mt-24 md:flex md:space-x-6 lg:space-x-8">
        <div className="md:w-2/3 flex flex-col">
          <div className="bg-white rounded-lg p-6 flex-1 flex flex-col">
            <h1 className="mb-4 text-3xl font-semibold">Stores</h1>

            {sortedStores.length ? (
              <>
                {sortedStores.map((s) => (
                  <Store key={s.bc_hash} store={s} />
                ))}
              </>
            ) : (
              <div className="flex-1 w-full flex flex-col items-center justify-center gap-6 p-12 -mt-4 text-gray-400">
                <SVG name="pointer" className="w-20 h-20 text-gray-300" />
                No stores yet. Add one!
              </div>
            )}
          </div>
        </div>
        <div className="md:w-1/3">
          <StoreForm />

          <button
            type="button"
            className="mt-4 bg-gray-100 w-full p-4 rounded-lg flex items-center gap-2 flex-1 hover:bg-indigo-100 hover:text-indigo-600 transition group"
            onClick={() => setShowSelector(true)}
          >
            <SVG
              name="info"
              className="w-7 h-7 text-gray-500 group-hover:text-indigo-500"
            />
            <div>Instructions on adding a store</div>
          </button>

          <Modal
            open={showSelector}
            setOpen={setShowSelector}
            icon="gear"
            title={`How to add your BigCommerce store`}
          >
            <div className="flex gap-8 p-1 mt-8">
              <div className="flex-1 flex flex-col">
                <h3 className="text-md font-semibold text-gray-900">
                  Video walkthrough
                </h3>

                <p className="text-gray-800">
                  Let us show you what info you need to gather.
                </p>

                <div
                  className="mt-1 overflow-hidden relative h-0 rounded-lg"
                  style={{ paddingBottom: '56.25%' }}
                >
                  <div
                    style={{ padding: '56.25% 0 0 0', position: 'relative' }}
                  >
                    <iframe
                      src="https://player.vimeo.com/video/759743877?h=12b9afb7af&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture"
                      webkitallowfullscreen="true"
                      mozallowfullscreen="true"
                      style={{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                        width: '100%',
                        height: '100%',
                      }}
                      title="BCtools.io Add Store"
                    ></iframe>
                  </div>
                  <script src="https://player.vimeo.com/api/player.js"></script>
                </div>
                <div className="hidden p-8">
                  <img
                    src="/img/video-thumb.jpg"
                    alt="video"
                    className="mt-8 rounded-2xl"
                  />
                </div>
                <p className="text-base leading-6 text-gray-700 pt-4 mt-auto">
                  A BigCommerce documentation article about{' '}
                  <a
                    className="link"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://developer.bigcommerce.com/api-docs/getting-started/authentication/rest-api-authentication#obtaining-store-api-credentials"
                  >
                    creating API credentials
                  </a>
                  .
                </p>
              </div>

              <div className="">
                <h3 className="text-md font-semibold text-gray-900">
                  Creating your API access
                </h3>
                <p className="text-gray-800">Use these settings:</p>
                <div className="p-2 rounded-md shadow-md border border-gray-200">
                  <img src="/img/required-privs.png" alt="OAuth scopes" />
                </div>
              </div>
            </div>
          </Modal>
          <div className="bg-gray-200 rounded-lg mt-4 p-4 flex flex-col items-center">
            <SVG name="shield" className="w-10 h-10 text-gray-500" />
            <p className="pt-1 text-gray-600 text-center text-xs max-w-xs">
              We pinky promise to keep your credentials extra secure. You can
              revoke the API credentials any time using your BigCommerce control
              panel.
            </p>
          </div>
        </div>
      </div>
    </main>
  )
}

export default Stores
